<hawk-record-navigation
  class="app-page"
  [breadcrumbLinkList]="[{ link: '/a/benutzer', description: 'Nutzer' }]"
  [root]="'user'"
  [leafDescription]="'Neuen Nutzer erstellen'"
>
  <div slot="toolbar" class="flex flex-row gap-2 items-center"></div>
  <div class="page-content px-4 pb-2 overflow-auto">
    <form class="page-sheet max-w-7xl mx-auto" [formGroup]="userForm" (submit)="onSubmit()">
      <div class="grid grid-flow-dense grid-cols-3">
        <div class="grid grid-flow-dense grid-cols-1">
          <fieldset class="bm-fieldset p-4 row-span-2">
            <legend class="bm-fieldset-legend text-lg">Stammdaten</legend>
            <ng-container [ngTemplateOutlet]="tplStammdaten" />
          </fieldset>
          <fieldset class="bm-fieldset p-4">
            <legend class="bm-fieldset-legend text-lg">Kontaktdaten</legend>
            <ng-container [ngTemplateOutlet]="tplKontaktdaten" />
          </fieldset>
        </div>

        <div class="grid grid-cols-2 col-span-2">
          <fieldset class="bm-fieldset p-4 relative">
            <legend class="bm-fieldset-legend text-lg">Adresse</legend>
            <div class="absolute -top-8 right-4 flex justify-end w-1/2 min-w-60" id="address_geocoder"></div>
            <ng-container [ngTemplateOutlet]="tplAdresse" />
          </fieldset>
          <fieldset class="bm-fieldset p-4 relative">
            <legend class="bm-fieldset-legend text-lg">Firmenadresse</legend>
            <div class="absolute -top-8 right-4 flex justify-end w-1/2 min-w-60" id="company_address_geocoder"></div>
            <ng-container [ngTemplateOutlet]="tplFirmenadresse" />
          </fieldset>
          <fieldset class="bm-fieldset p-4">
            <legend class="bm-fieldset-legend text-lg">Angestellt bei Subunternehmer</legend>
            <ng-container [ngTemplateOutlet]="tplSubunternehmer" />
          </fieldset>
          <fieldset class="bm-fieldset p-4 row-span-2">
            <legend class="bm-fieldset-legend text-lg">Nutzerrollen</legend>
            <ng-container [ngTemplateOutlet]="tplNutzerrollen" />
          </fieldset>
          <fieldset class="bm-fieldset p-4">
            <legend class="bm-fieldset-legend text-lg">Sonstiges</legend>
            <ng-container [ngTemplateOutlet]="tplSonsiges" />
          </fieldset>
        </div>
      </div>

      <!-- Bestandsautomatik schon beim Anlegen: die Zeilen hängen noch an
           keinem Nutzer und werden deshalb erst nach dem Erstellen gespeichert. -->
      @if (hasTechnicianRole) {
        <fieldset class="bm-fieldset p-4 mt-4">
          <legend class="bm-fieldset-legend text-lg">Materialbestand</legend>
          <hawk-technician-stock-levels-grid
            [mode]="'technician'"
            [addressState]="userForm.controls.state.value"
            (draftsChange)="stockLevelDrafts = $event"
          />
        </fieldset>
      }

      @if (saveError) {
        <div class="bm-alert bm-alert-error bm-alert-soft mt-4">
          <i class="fa fa-exclamation-circle"></i>
          <span>{{ saveError }}</span>
        </div>
      }

      <div class="flex flex-row gap-2 items-center justify-end mt-4">
        <a [routerLink]="'/benutzer/'" class="bm-btn"> Abbrechen </a>
        <button class="bm-btn bm-btn-primary" [disabled]="!userForm.valid">Erstellen</button>
      </div>
    </form>
  </div>
</hawk-record-navigation>

<ng-template #tplStammdaten>
  <label class="bm-fieldset-label">Vorname</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.first_name" [ngClass]="{ 'border-red-500': userForm.controls.first_name.invalid }"/>

  <label class="bm-fieldset-label">Nachname</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.last_name" [ngClass]="{ 'border-red-500': userForm.controls.last_name.invalid }"/>

  <label class="bm-fieldset-label">E-Mail</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.email1" [ngClass]="{ 'border-red-500': userForm.controls.email1.invalid }"/>

  <label class="bm-fieldset-label">Zusätzliche E-Mail</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.email2" />
  <label>
    Nachrichten werden zusätzlich per CC an diese E-Mail-Adressen gesendet. Mehrere E-Mail können mit einem Semikolon
    getrennt angegeben werden.
  </label>

  <label class="bm-fieldset-label">E-Mail MoreApp</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.email_moreapp" [ngClass]="{ 'border-red-500': userForm.controls.email_moreapp.invalid }"/>
  <label>Diese E-Mail-Adresse wird für die Zuordnung in der MoreApp benutzt.</label>

  <label class="bm-fieldset-label">Partner E-Mail</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.email_partner1" [ngClass]="{ 'border-red-500': userForm.controls.email_partner1.invalid }"/>

  <label class="bm-fieldset-label">Zusätzliche Partner E-Mail</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.email_partner2" />
  <label>Mehrere E-Mail können mit einem Semikolon getrennt angegeben werden.</label>

  <label class="bm-fieldset-label">Kunde</label>
  <select class="bm-select w-full" [formControl]="userForm.controls.customer_id">
    <option value="">-Keine Zuordnung-</option>
    @for (customer of customers; track $index) {
      <option [value]="customer.id">{{ customer.name }}</option>
    }
  </select>

  <label class="bm-fieldset-label">Passwort</label>
  <input class="bm-input w-full" type="password" [formControl]="userForm.controls.password" [ngClass]="{ 'border-red-500': userForm.controls.password.invalid }"/>
</ng-template>

<ng-template #tplKontaktdaten>
  <label class="bm-fieldset-label">Telefon (Beruflich)</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.phone1" [ngClass]="{ 'border-red-500': userForm.controls.phone1.invalid }"/>

  <label class="bm-fieldset-label">Telefon (Privat)</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.phone2" />

  <label class="bm-fieldset-label">Telefon für Dispatching</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.telephone_dispatching" [ngClass]="{ 'border-red-500': userForm.controls.telephone_dispatching.invalid }"/>
</ng-template>

<ng-template #tplAdresse>
  <label class="bm-fieldset-label">Firma</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.company" />

  <label class="bm-fieldset-label">Straße</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.street" />

  <label class="bm-fieldset-label">PLZ / Ort</label>
  <div class="flex flex-row gap-2">
    <input class="bm-input flex-1" type="text" [formControl]="userForm.controls.zip" [ngClass]="{ 'border-red-500': userForm.controls.zip.invalid }"/>
    <input class="bm-input flex-2" type="text" [formControl]="userForm.controls.city" />
  </div>

  <label class="bm-fieldset-label">Land / Staat</label>
  <div class="flex flex-row gap-2">
    <input class="bm-input flex-1" type="text" [formControl]="userForm.controls.country" />
    <input class="bm-input flex-2" type="text" [formControl]="userForm.controls.state" />
  </div>
</ng-template>

<ng-template #tplFirmenadresse>
  <label class="bm-fieldset-label">Firma</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.company_address_company" />

  <label class="bm-fieldset-label">Straße</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.company_address_street" />

  <label class="bm-fieldset-label">PLZ / Ort</label>
  <div class="flex flex-row gap-2">
    <input
      class="bm-input flex-1"
      type="text"
      [formControl]="userForm.controls.company_address_zip"
      [ngClass]="{ 'border-red-500': userForm.controls.company_address_zip.invalid }"
    />
    <input class="bm-input flex-2" type="text" [formControl]="userForm.controls.company_address_city" />
  </div>

  <label class="bm-fieldset-label">Land / Staat</label>
  <div class="flex flex-row gap-2">
    <input class="bm-input flex-1" type="text" [formControl]="userForm.controls.company_address_country" />
    <input class="bm-input flex-2" type="text" [formControl]="userForm.controls.company_address_state" />
  </div>
</ng-template>

<ng-template #tplSubunternehmer>
  <label class="bm-fieldset-label">Angestellt bei Subunternehmer</label>
  <select class="bm-select w-full" [formControl]="userForm.controls.employer_id">
    <option value="">-</option>
    @for (subcontractor of subcontractors; track $index) {
      <option [value]="subcontractor.id">{{ subcontractor.name }}</option>
    }
  </select>
</ng-template>

<ng-template #tplNutzerrollen>
  <div class="flex flex-col gap-y-1">
    @for (checked_role of checkedRoles; track checked_role.role.id) {
      <label>
        <input
          type="checkbox"
          class="bm-checkbox"
          [(ngModel)]="checked_role.checked"
          [ngModelOptions]="{ standalone: true }"
        />
        {{ checked_role.role.name }}
      </label>
    }
  </div>
  @if (hasDispatcherRole) {
    <div class="border-t border-base-300 mt-3 pt-3">
      <label class="bm-fieldset-label">Dispatcher-Farbe</label>
      <app-color-picker
        class="block mt-1"
        [palette]="dispatcherColorPalette"
        [value]="dispatcherColor()"
        placeholderColor="#4ECDC4"
        emptyHint="Keine feste Farbe (Palette wird verwendet)"
        (valueChange)="dispatcherColor.set($event)"
      />
    </div>
  }
  @if (hasTechnicianRole) {
    <div class="border-t border-base-300 mt-3 pt-3">
      <label class="bm-fieldset-label">Tourfarbe (Dashboard und Planungsassistent)</label>
      <app-color-picker
        class="block mt-1"
        [palette]="tourColorPalette"
        [value]="tourColor()"
        emptyHint="Keine feste Farbe (Palette wird verwendet)"
        (valueChange)="tourColor.set($event)"
      />
    </div>
  }
</ng-template>

<ng-template #tplSonsiges>
  <label class="bm-fieldset-label">Versandfiliale (interner Materialversand)</label>
  <div class="bm-join w-full">
    <input
      class="bm-join-item bm-input w-full"
      type="text"
      readonly
      placeholder="-Keine Zuordnung-"
      [value]="internalShippingStore()?.name || ''"
    />
    <button class="bm-join-item bm-btn" type="button" (click)="showStorePicker.set(true)">Wählen</button>
    @if (internalShippingStore()) {
      <button class="bm-join-item bm-btn bm-btn-square" type="button" (click)="clearShippingStore()">✕</button>
    }
  </div>
  @if (missingInternalShippingStore) {
    <div class="bm-alert bm-alert-warning bm-alert-soft mt-1">
      <i class="fa fa-exclamation-triangle"></i>
      <span>Bentomax-Techniker sollten eine Versandfiliale zugeordnet bekommen.</span>
    </div>
  }

  <label class="bm-fieldset-label">Karten-Nr der Packstation</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.card_nr_packstation" />

  <label class="bm-fieldset-label">Pickpoint-Nr</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.pickpoint_nr" />

  <label class="bm-fieldset-label">XML-ID (für Ticket-Export)</label>
  <input class="bm-input w-full" type="text" [formControl]="userForm.controls.xml_id" />

  <label class="bm-fieldset-label">Notizen</label>
  <textarea class="bm-textarea w-full" [formControl]="userForm.controls.comment" ></textarea>

</ng-template>

<!-- Filial-Picker für die Versandfiliale -->
@if (showStorePicker()) {
  <app-store-picker
    [projectIds]="[internalShippingProjectId]"
    [onlyUnassigned]="true"
    [showAssignedUserColumn]="false"
    [passSearchAsCreateStoreName]="true"
    [initialSearch]="shippingStoreSearchPrefill"
    heading="Versandfiliale auswählen"
    (storeSelected)="onShippingStoreSelected($event)"
    (closed)="showStorePicker.set(false)"
  />
}
